import React from "react";
import { withStyles } from "material-ui/styles";
import classnames from "classnames";

const styles = {};

const CTableBody = props => {
  const { children, classes, className, ...otherProps } = props;

  return (
    <tbody {...otherProps} className={classnames(className)}>
      {children}
    </tbody>
  );
};

export default withStyles(styles)(CTableBody);



// WEBPACK FOOTER //
// ./src/uis/CTable/CTableBody.jsx